import * as z from "zod";

// Create validation schema
export const subscriptionFormSchema = z.object({
  type: z.string({
    required_error: "Please select a subscription type",
  }),
  price: z.string().min(1, "Price is required"),
  paymentMethod: z.string({
    required_error: "Please select a payment method",
  }),
  startDate: z.date({
    required_error: "Start date is required",
  }),
  endDate: z.date({
    required_error: "End date is required",
  }).refine(date => date > new Date(), {
    message: "End date must be in the future",
  }),
  sessionsTotal: z.number().min(1, "Number of sessions must be at least 1"),
  jokersTotal: z.number().min(0, "Number of jokers cannot be negative").default(0),
  paymentFrequency: z.string().optional().default('one-time'),
  isManuallyActivated: z.boolean().default(false),
  subscriptionDuration: z.number().min(0, "Duration cannot be negative").default(1),
});

export type SubscriptionFormValues = z.infer<typeof subscriptionFormSchema>;

// Helper to check if a subscription is expired
export const isSubscriptionExpired = (endDate: Date | string): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expiryDate = new Date(endDate);
  expiryDate.setHours(0, 0, 0, 0);
  return expiryDate < today;
};

// Calculate new expiration date after a pause
export const calculateNewExpiryAfterPause = (
  originalExpiry: Date | string, 
  pauseStart: Date | string, 
  resumeDate: Date | string
): Date => {
  const expiryDate = new Date(originalExpiry);
  const startDate = new Date(pauseStart);
  const endDate = new Date(resumeDate);
  
  // Calculate pause duration in days
  const pauseDuration = Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
  
  // Add pause duration to expiry date
  expiryDate.setDate(expiryDate.getDate() + pauseDuration);
  
  return expiryDate;
};
